import { render, staticRenderFns } from "./FooterAbout.vue?vue&type=template&id=47f5b72f&"
import script from "./FooterAbout.vue?vue&type=script&lang=js&"
export * from "./FooterAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports